import TableCell from '@material-ui/core/TableCell';
import ActiveDownloadIcon from '../../icons/Download';
import compiler from '../../view/Fields';


export default function available_fields(view_fields) {
    
    const renderUpdate = (sign) => {
        if(parseInt(sign.last_update_status) === 2) return (<ActiveDownloadIcon width={50} height={50} />);
        return '';
    };

    const fields = [{
        name : 'address',
        label : 'Address',
    }, {
        name : 'amberAlert',
        label : 'Instant Critical Message'
    }, {
        name : 'analogDataRecorder',
        label : 'Record analog data',
        type : 'BOOLEAN'
    }, {
        name : 'analogSamplesPerFile',
        label : 'Analog samples per file',
        type : 'INT'
    }, {
        name : 'auto_update',
        label : 'Automatically Download Data',
        type : 'BOOLEAN'
    }, {
        name : 'baud_rate',
        label : 'Baud rate',
        type : 'INT'
    }, {
        name : 'binPeriod',
        label : 'Analog cadence',
        type : 'INT'
    }, {
        name : 'com_ip_port',
        label : 'Communication port',
        type : 'INT'
    }, {
        name : 'config_description',
        label : 'Configuration description'
    }, {
        name : 'config_name',
        label : 'Configuration'
    }, {
        name : 'current_update_status',
        label : 'Update status',
        type : 'INT',
        
    }, {
        name : 'customer_zone',
        label : 'Zone'
    }, {
        name : 'dataDelay',
        label : 'Data Delay',
        type : 'INT'
    }, {
        name : 'default_config',
        label : 'Default Configuration',
        type : 'INT'
    }, {
        name : 'description',
        label : 'Description',
    }, {
        name : 'effectiveness',
        label : 'Effectiveness',
        type : 'DECIMAL'
    }, {
        name : 'flowControl',
        label : 'Flow Control',
        type : 'BOOLEAN'
    }, {
        name : 'ftp_ip_port',
        label : 'FTP Port',
        type : 'INT'
    }, {
        name : 'geo_location',
        label : 'GPS Coordinates',
    }, {
        name : 'gps_enable',
        label : 'GPS',
        type : 'BOOLEAN'
    }, {
        name : 'gps_timeout',
        label : 'GPS Timeout',
        type : 'INT'
    }, {
        name : 'hexver',
        label : 'Firmware'
    }, {
        name : 'id',
        label : 'ID',
        type : 'INT'
    }, {
        name : 'ip',
        label : 'IP',
        render : (sign) => {
            return (<TableCell>{sign.ip ? sign.ip : ''}</TableCell>)
        }
    }, {
        name : 'ip_verification',
        label : 'IP Verified',
        type : 'BOOLEAN'
    }, {
        name : 'itsheight',
        label : 'ITS Height',
        type : 'INT'
    }, {
        name : 'itswidth',
        label : 'ITS Width',
        type : 'INT'
    }, {
        name : 'kill_update',
        label : 'Stop update in-progress',
        type : 'BOOLEAN'
    }, {
        name : 'last_auto_update',
        label : 'Last auto-update',
        type : 'DATETIME'
    }, {
        name : 'last_pri_download',
        label : 'Last Configuration Download',
        type : 'DATETIME'
    }, {
        name : 'last_status_change',
        label : 'Last Status Change',
        type : 'DATETIME'
    }, {
        name : 'last_update',
        label : 'Last Modified',
        type : 'DATETIME'
    }, {
        name : 'last_update_error',
        label : 'Last Error'
    }, {
        name : 'last_update_status',
        label : 'Update Status',
        type : 'INT',
        render : (sign) => {
            let us = [
                'Failed',
                'Completed successfully',
                'In-progress'
            ];
            return (<TableCell>{us[sign.last_update_status]}</TableCell>)
        }
    }, {
        name : 'load_pri',
        label : 'Update configuration',
        type : 'BOOLEAN'
    }, {
        name : 'location',
        label : 'Location'
    }, {
        name : 'max_spl_speed',
        label : 'Maximum stat display speed',
        type : 'INT'
    }, {
        name : 'minTravelTime',
        label : 'Minimum travel time',
        type : 'INT'
    }, {
        name : 'next_update',
        label : 'Next scheduled update',
        type : 'DATETIME'
    }, {
        name : 'options',
        label : 'Options',
        type : 'HIDDEN'
    }, {
        name : 'organization',
        label : 'Organization',
        type : 'INT'
    }, {
        name : 'owner',
        label : 'Owner',
        type : 'HIDDEN'
    }, {
        name : 'pic',
        label : 'Picture',
        type : 'HIDDEN'
    }, {
        name : 'pic_id',
        label : 'Picture ID',
        type : 'HIDDEN'
    }, {
        name : 'pic_path',
        label : 'Picture',
        type : 'HIDDEN'
    }, {
        name : 'pixel_date',
        label : 'Display Test Date',
        type : 'DATETIME'
    }, {
        name : 'pixel_map',
        label : 'Display Test',
        type : 'PIXELMAP'
    }, {
        name : 'pixel_test_enable',
        label : 'Test Pixels',
        type : 'BOOLEAN'
    }, {
        name : 'powerMiser',
        label : 'Power Miser',
        type : 'BOOLEAN'
    }, {
        name : 'primary_config',
        label : 'Primary Configuration',
        type : 'HIDDEN'
    }, {
        name : 'process_stats',
        label : 'Enable Stats Processing',
        type : 'BOOLEAN'
    }, {
        name : 'processing_stats',
        label : 'Stats processing in-progress',
        type : 'BOOLEAN'
    }, {
        name : 'prod_name',
        label : 'Product'
    }, {
        name : 'radarDataRecorder',
        label : 'Record Radar Data',
        type : 'BOOLEAN'
    }, {
        name : 'reg_status',
        label : 'Registered',
        type : 'BOOLEAN'
    }, {
        name : 'roadConditions',
        label : 'Road Conditions',
        type : 'BOOLEAN'
    }, {
        name : 'samplePeriod',
        label : 'Analog sample period',
        type : 'INT'
    }, {
        name : 'samplesPerFile',
        label : 'Radar samples per file',
        type : 'INT'
    }, {
        name : 'serialNumber',
        label : 'Serial Number'
    }, {
        name : 'service_zone',
        label : 'Serice Zone',
    }, {
        name : 'pd_zone',
        label : 'PD Zone',
    }, {
        name : 'sign_dom',
        label : 'DOM',
        type : 'DATETIME'
    }, {
        name : 'sign_id',
        label : 'Sign ID',
        type : 'HIDDEN'
    }, {
        name : 'sign_type',
        label : 'Type',
        type : 'INT',
        render : (sign) => {
            return(<TableCell style={{
                backgroundImage:'url("http://forteltraffic.com/'+encodeURI(sign.pic_path)+'")', 
                backgroundSize:'contain', 
                backgroundRepeat:'no-repeat', 
                backgroundPosition:'center'
            }}>
                {renderUpdate(sign)}
                {sign.pic_path ? '' : sign.type_name}
            </TableCell>);
        }
    }, {
        name : 'sn_verification',
        label : 'SN Verified',
        type : 'BOOLEAN'
    }, {
        name : 'test_com',
        label : 'Test Communications',
        type : 'BOOLEAN'
    }, {
        name : 'timeZone',
        label : 'Time Zone'
    }, {
        name : 'travel_time_message',
        label : 'Travel Time Message',
        type : 'HIDDEN'
    }, {
        name : 'travel_time_timing',
        label : 'Travel Time Timing',
        type : 'HIDDEN'
    }, {
        name : 'type_description',
        label : 'Type Description'
    }, {
        name : 'type_name',
        label : 'Type Name'
    }, {
        name : 'type_part',
        label : 'Part Number'
    }, {
        name : 'type_verification',
        label : 'Type Verified',
        type : 'BOOLEAN'
    }, {
        name : 'update_time',
        label : 'Update Schedule',
        type : 'TIME'
    }, {
        name : 'wigWagState',
        label : 'Wig Wag State',
        type : 'HIDDEN'
    }];

    const compileField = compiler(fields);
    
    if(view_fields){
        return view_fields.map(compileField);
    }
    return fields.map(compileField);
    
}